module.exports = __webpack_public_path__ + "assets/delivery-9b6bde.svg";